import React from 'react'

const DownloadBtn = props => (
  <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g filter='url(#filter0_d)'>
      <rect x='6' y='6' width='24' height='24' rx='5' fill='#1D79FB' />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24.0002 20.6667C24.3421 20.6667 24.6238 20.9241 24.6623 21.2556L24.6668 21.3334V22.6667C24.6668 23.7318 23.8342 24.6025 22.7843 24.6633L22.6668 24.6667H13.3335C12.2684 24.6667 11.3977 23.8341 11.3369 22.7842L11.3335 22.6667V21.3334C11.3335 20.9652 11.632 20.6667 12.0002 20.6667C12.3421 20.6667 12.6238 20.9241 12.6623 21.2556L12.6668 21.3334V22.6667C12.6668 23.0086 12.9242 23.2904 13.2557 23.3289L13.3335 23.3334H22.6668C23.0087 23.3334 23.2905 23.076 23.329 22.7445L23.3335 22.6667V21.3334C23.3335 20.9652 23.632 20.6667 24.0002 20.6667ZM18.0002 11.3334C18.3684 11.3334 18.6668 11.6319 18.6668 12V18.39L19.5288 17.5286C19.7691 17.2883 20.1472 17.2698 20.4088 17.4732L20.4716 17.5286C20.7119 17.769 20.7304 18.1471 20.527 18.4086L20.4716 18.4714L18.4716 20.4714L18.4423 20.499L18.397 20.5358L18.3229 20.5836L18.2477 20.6192L18.1775 20.6428L18.0785 20.6622L18.0002 20.6667L17.95 20.6648L17.8663 20.6532L17.7921 20.6335L17.718 20.6043L17.653 20.5694L17.589 20.5249C17.5679 20.5083 17.5477 20.4904 17.5288 20.4714L15.5288 18.4714C15.2684 18.2111 15.2684 17.789 15.5288 17.5286C15.7691 17.2883 16.1472 17.2698 16.4088 17.4732L16.4716 17.5286L17.3335 18.39V12C17.3335 11.6319 17.632 11.3334 18.0002 11.3334Z'
      fill='white'
    />
    <defs>
      <filter id='filter0_d' x='0' y='0' width='36' height='36' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
        <feOffset />
        <feGaussianBlur stdDeviation='3' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
      </filter>
    </defs>
  </svg>
)

export default DownloadBtn
